export enum GoogleAd {
	FEED,
	BANNER,
	MULTIPLEX,
}
